module.exports = {"AGENDA_TITLE":"My agenda","AGENDA_MONTH":"Month","AGENDA_WEEK":"Week","AGENDA_ALL":"All","AGENDA_APPOINTMENT":"Intervention","AGENDA_EVENT":"Event","AGENDA_START":"Start","AGENDA_END":"End","AGENDA_TICKET":"Ticket","AGENDA_BLOCK":"Block","AGENDA_INDEPENDENT_CONTRACTOR":"Independent contractor | Independent contractor(s)","AGENDA_PARTICIPANT":"Participant | Participant(s)","AGENDA_WELCOMING":"Welcoming | Welcoming(s)","AGENDA_MODAL_TITLE_EVENT_MODIFICATION":"Modify event"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/agenda/agenda.en.json
// module id = 6na/
// module chunks = 0